<template>
  <a-modal
    centered
    width="calc(100% - 80px)"
    :visible="visible"
    :closable="false"
    :mask-closable="false"
    :footer="null"
    wrap-class-name="lesson-in-info-pop"
  >
    <template slot="title">
      <span class="lesson-in-info-title">
        <!--  -->
        <span class="title">
          {{ groupInfo.groupName }}
          <span class="split" />
          <a-tooltip v-if="groupInfo.itvCourseName && groupInfo.itvCourseName.length > 10" placement="top">
            <template slot="title">
              <span>{{ groupInfo.itvCourseName }}</span>
            </template>
            <span class="limit-content">{{ groupInfo.itvCourseName }}</span>
          </a-tooltip>
          <span class="limit-content" v-else>{{ groupInfo.itvCourseName }}</span>
        </span>
        <!--  -->
        <span v-if="groupInfo.sourceType !== 2" class="item">第{{ lessonInfo.lessonNum }}讲</span>
        <!--  -->
        <span class="item" v-if="lessonInfo.lessonName && groupInfo.sourceType !== 2">
          <a-tooltip v-if="lessonInfo.lessonName && lessonInfo.lessonName.length > 10" placement="top">
            <template slot="title">
              <span>{{ lessonInfo.lessonName }}</span>
            </template>
            <span class="limit-content">{{ lessonInfo.lessonName }}</span>
          </a-tooltip>
          <span class="limit-content" v-else>{{ lessonInfo.lessonName }}</span>
        </span>
        <!--  -->
        <span class="item">共{{ groupInfo.studentNum }}人</span>
        <!--  -->
        <span class="item">课程ID：{{ groupInfo.classTypeId }}</span>
      </span>
      <span class="lesson-in-info-title-close" @click="handleCancel">
        <i class="icon-close iconfont delete" />
      </span>
    </template>
    <template v-if="groupInfo.sourceType === 2">
      <div class="wrapper">
        <!-- coursePackageId: 2975 -->
        <InJzxTool
          v-if="jzxVisible"
          page-type="2"
          :page-params="{
            coursePackageId: groupInfo.classTypeId,
            sourceType: 4,
            isEdit: false
          }"
        />
      </div>
    </template>
    <template v-else>
      <div class="wrapper">
        <div class="tabs">
          <span v-for="(tab, index) in tabs" :key="index">
            <a-button :type="isSelected(tab.value)" @click="updateType(tab.value)"><span v-html="tab.label" /></a-button>
          </span>
        </div>
        <div class="container">
          <!-- 课程配置 -->
          <CourseConfig
            v-show="type === TYPE.CONFIG"
            :is-show="type === TYPE.CONFIG"
            :lesson-info="lessonInfo"
            @handleCancel="handleCancel"
            :tab-type="type"
          />
          <!-- 课件 -->
          <CourseWare v-if="type === TYPE.COURSEWARE" :class-type-id="lessonInfo.classTypeId" :lesson-id="lessonInfo.lessonId" />
          <!-- 补充资料 -->
          <SupMaterial v-if="type === TYPE.MATERIAL" :class-type-id="lessonInfo.classTypeId" :lesson-id="lessonInfo.lessonId" />
          <Analysis v-if="type === TYPE.ANALYSIS" :class-type-id="lessonInfo.classTypeId" :lesson-id="lessonInfo.lessonId" />
        </div>
      </div>
    </template>
  </a-modal>
</template>

<script>
import CourseConfig from './courseConfig/index.vue'
import CourseWare from './courseWare/index.vue'
import SupMaterial from './supMaterial/index.vue'
import Analysis from './analysis/index.vue'
import InJzxTool from '@/components/InJzxTool/index.vue'
import { TYPE } from './constants'

export default {
  components: {
    SupMaterial,
    CourseWare,
    CourseConfig,
    Analysis,
    InJzxTool
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    groupInfo: {
      type: Object,
      default: () => {}
    },
    lessonInfo: {
      type: Boolean,
      default: () => {}
    }
  },
  data() {
    return {
      jzxVisible: false,
      TYPE,
      type: TYPE.CONFIG,
      tabs: [{
        label: '课程配置',
        value: TYPE.CONFIG
      }, {
        label: '课件',
        value: TYPE.COURSEWARE
      }, {
        label: '讲次</br>补充资料',
        value: TYPE.MATERIAL
      }, {
        label: '题目解析',
        value: TYPE.ANALYSIS
      }]
    }
  },
  methods: {
    handleCancel() {
      this.$emit('updatePrePareVisible', false)
    },
    isSelected(value) {
      return value === this.type ? 'primary' : 'default'
    },
    updateType(value) {
      this.type = value
    }
  },
  created() {
    this.jzxVisible = true
    console.log('created', this.jzxVisible)
  },
  beforeDestroy() {
    this.jzxVisible = false
    console.log('unmounted', this.jzxVisible)
  }
}
</script>

<style scoped lang="less">
  // 弹框&顶部输入内容样式
  :deep(.lesson-in-info-pop) {
    .ant-modal-header {
      padding: 0 !important;
      .ant-modal-title {
        display:flex;
        height: 53px;
        padding: 0 24px;
        justify-content: space-between;
        align-items: center;
      }
    }
    .lesson-in-info-title {
      flex: 1;
      width: 0;
      height: 22px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;

      .title {
        width: 364px;
        height: 22px;
        font-weight: 700;
        font-size: 16px;
        line-height: 22px;
        color: #505873;
        padding-right: 16px;
        margin-right: -4px;
      }
      .split {
        display: inline-block;
        width: 1.5px;
        height: 16px;
        margin: 0 12px;
        background: #505873;
        position: relative;
        top: 3px;
      }
      .item {
        line-height: 22px;
        border-left: 1px solid #EBEDF0;
        padding: 0 16px;
        color: #70788C;
        font-size: 14px;
        font-weight: 400;
        margin-right: -4px;
      }

      .limit-content {
        display: inline-block;
        max-width: 170px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        vertical-align: top;
      }

      &-close {
        position: relative;
        right: -4px;
        font-size: 19px;
        cursor: pointer;
        color: #98A2B2;
        > i {
          font-size: 19px;
        }
      }
    }
    .ant-modal-body {
      padding: 0;
    }
  }

  // 内容区-左侧
  .wrapper {
    display: flex;
    // header高度 2个边距
    height: calc(100vh - 53px - 40px - 40px);
    .tabs {
      width: 131px;
      border-right: 1px solid #EBEDF0;
      padding: 20px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;

      :deep(.ant-btn) {
        width: 91px;
        min-height: 38px;
        height: auto;
        line-height: 20px;
        border-radius: 4px;
        margin-bottom: 12px;
        padding: 8px 17px;
        font-weight: 700;
        border: 2px solid transparent;
      }

      .ant-btn-default {
        color: #70788C;
        border-color: #EBEDF0;
      }

    }
    .container {
      flex: 1;
      height: 100%;
    }
  }
</style>
